import { useEffect, useRef } from "react";
import { App } from "antd";
import { useNavigate } from "react-router-dom";
import { onSessionUnauthorized } from "../authUnauthorized";
import { textMap } from "../i18n";
import { useUiState } from "../state";

/** 注册 API 401（非登录页）时的提示：清除登录态并引导重新登录 */
export function AuthSessionExpiredNotifier() {
  const { modal } = App.useApp();
  const navigate = useNavigate();
  const { lang, clearAuthSession } = useUiState();
  const modalOpenRef = useRef(false);

  useEffect(() => {
    const t = textMap[lang];
    return onSessionUnauthorized(() => {
      if (modalOpenRef.current || typeof window === "undefined") {
        return;
      }
      if (!localStorage.getItem("xtool_token")) {
        return;
      }
      modalOpenRef.current = true;
      clearAuthSession();
      modal.warning({
        title: t.sessionExpiredTitle,
        content: t.sessionExpiredDesc,
        okText: t.sessionExpiredGoLogin,
        centered: true,
        onOk: () => {
          modalOpenRef.current = false;
          navigate("/login", { replace: true });
        },
        onCancel: () => {
          modalOpenRef.current = false;
        },
      });
    });
  }, [modal, navigate, clearAuthSession, lang]);

  return null;
}
